const VERIFIED_QUOTE_TEMP_PREFIX = 'verified-quote-temp-';

export const getVerifiedQuoteTempId = (quoteId: string) => `${VERIFIED_QUOTE_TEMP_PREFIX}-${quoteId}`;
